import React from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import { Avatar, Input, Col, Layout, List, Row } from 'antd';

import OrderModal from '../orders-v2/modal';

import { setActiveOrder } from '../orders/actions';
import { 
	_getSearchOrders,
	_getAdmins,
	_getQbDepositToAccounts,
	_getQbExpenseAccounts,
	_getQbPaymentMethods,
	_getQbTerms
} from '../../services';


class OrderSearch extends React.Component {

    constructor( props ){
		super(props);

		this.state = {
			fullDataLoaded: false,
			searchTerm: "",
			orders: [],

			admins: false,
			qbPaymentMethods: false,
			qbDepositToAccounts: false,
			qbExpenseAccounts: false,
			qbTerms: false,

			bugReportModalVisible: false
		}

		this.handleDoSearch = debounce( this.handleDoSearch, 300 );
	}


    render() {

        const { activeOrder } = this.props;

        return (
            <Col >
                <Input
                    onClick={this.handleDoSearch}
                    placeholder="Ref Number"
                    value={this.state.searchTerm}
                    onChange={this.handleChangeSearch} />

                {
                    this.state.orders.length > 0 && (
                        <List
                            className="search-dropdown"
                            dataSource={this.state.orders}
                            renderItem={item => (
                                <List.Item>
                                    <div onClick={() => this.handleOnClickOrder(item)}>
                                        REF: {item.refNumber}<br />
                                        {item.paynowRefNumber ? `PN: ${item.paynowRefNumber}` : null}
                                    </div>
                                </List.Item>
                            )}
                        />
                    )
                }

                {activeOrder.data && this.state.fullDataLoaded ?
                    <OrderModal
                        cartId={activeOrder.data._id}
                        order={activeOrder.data}
						admins={this.state.admins}
						
                        qbPaymentMethods={this.state.qbPaymentMethods}
                        qbDepositToAccounts={this.state.qbDepositToAccounts}
                        qbExpenseAccounts={this.state.qbExpenseAccounts}
                        qbTerms={this.state.qbTerms}
                    /> :
                    ""
                }

            </Col>
        )
    }

    componentWillMount(){

		Promise.all([
			_getAdmins(),
			_getQbPaymentMethods(),
			_getQbDepositToAccounts(),
			_getQbExpenseAccounts(),
			_getQbTerms()
		])
			.then(([adminRes,paymentMethodsRes, depositToAccountsRes, expenseAccountsRes, termsRes])=>{

				const qbPaymentMethods = paymentMethodsRes.data.paymentMethods;
				const qbDepositToAccounts = depositToAccountsRes.data.depositToAccounts;
				const qbExpenseAccounts = expenseAccountsRes.data.expenseAccounts
				const qbTerms = termsRes.data.terms;
				const admins = adminRes.data.users;

				this.setState({
					qbPaymentMethods,
					qbDepositToAccounts,
					qbExpenseAccounts,
					qbTerms,
					admins,
					fullDataLoaded: true
				})

			})
	
    }
    
    handleChangeSearch = ( e ) => {

		this.setState({
			searchTerm: e.target.value,
			orders: []
		});

		this.handleDoSearch();
	}

	handleOnClickOrder = ( order ) => {

		this.setState({ orders:[] })
		this.props.setActiveOrder( order );

	}

	handleDoSearch = () => {
		
		const { searchTerm } = this.state;

		if( !searchTerm ) return;
		_getSearchOrders( searchTerm )
			.then( res => {
				this.setState({ orders: res.data.orders });
			})

	}


}

export default connect(
	state => ({
		activeOrder: state.activeOrder
	}),
	dispatchEvent => ({
		setActiveOrder: ( order ) => dispatchEvent( setActiveOrder( order ) )
	})
)(OrderSearch);


// WEBPACK FOOTER //
// ./src/components/toolbar/order-search.js